import { type CanDeactivateFn } from '@angular/router';
import { isWithForm, isWithFormState, type WithForm, type WithFormState } from '@pct-ng/form';
import { openConfirmDialog } from '@pct-ng/feature-message-material';
import { map } from 'rxjs/operators';

export type DirtyCheckStrategy = 'FormState' | 'HasDirtyCheck';

export interface HasDirtyCheck {
  isDirty: boolean;
}

export const dirtyCheckCanDeactivateGuard: (
  strategy?: DirtyCheckStrategy,
) => CanDeactivateFn<WithForm | WithFormState | HasDirtyCheck> =
  (strategy: DirtyCheckStrategy = 'FormState') =>
  cmp => {
    let dirty = false;
    if (strategy === 'FormState') {
      if (isWithForm(cmp)) {
        dirty = cmp.form.formState === 'NOT_SAVED';
      } else if (isWithFormState(cmp)) {
        dirty = cmp.formState === 'NOT_SAVED';
      }
    } else if (strategy === 'HasDirtyCheck' && 'isDirty' in cmp) {
      dirty = cmp.isDirty;
    }
    if (dirty) {
      return openConfirmDialog({
        title: 'UNSAVED_CHANGES.TITLE',
        message: 'UNSAVED_CHANGES.MESSAGE',
      }).pipe(map(confirm => confirm?.result === 'SUBMIT'));
    }
    return true;
  };
